<template>
  <validation-observer v-slot="{ handleSubmit, reset }">
    <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" class="main_form step2form">
      <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b41-343646d4" class="form_field">
        <validation-provider class="w-100" :name="$t('MANUFACTURER')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-6">
              <label class="field_label">{{ $t('MANUFACTURER') }}</label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-6"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
            <select v-model="data.CS_VEHICLE.MANUFACTURER" @change="changeManufacturer">
              <!-- <option class="dropdown-link w-dropdown-link" value="" selected>{{ $t('SELECT_MANUFACTURER') }}</option> -->
              <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLov(data.ET_LOVS, 'MANUFACTURER')" :key="item.VALUE" :value="item.VALUE">{{
                item.TEXT || $t('SELECT_MANUFACTURER')
              }}</option>
            </select>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b42-343646d4" class="form_field">
        <validation-provider class="w-100" :name="$t('MANUFACTURE_YEAR')" rules="required|digits:4" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-4">
              <label class="field_label">{{ $t('MANUFACTURE_YEAR') }}</label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-8"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <cleave-date classes="text_field_input text-field w-input" v-model="data.CS_VEHICLE.MANUFACTURE_YEAR" name="MANUFACTURE_YEAR" placeholder="2021"></cleave-date>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_4d4da81d-6b61-9692-dcce-9742bec74b66-343646d4" class="form_field">
        <validation-provider class="w-100" :name="$t('ENGINE_CAPACITY')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-4">
              <label class="field_label">{{ $t('ENGINE_CAPACITY') }}</label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-8"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <input v-model="data.CS_VEHICLE.ENGINE_CAPACITY" type="text" name="ENGINE_CAPACITY" class="text_field_input text-field w-input" placeholder="1400" />
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_7ae4afab-7ebd-b931-6044-b8ca85fa0bd4-343646d4" class="form_field">
        <validation-provider class="w-100" :name="$t('SEATS')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-6">
              <label class="field_label">{{ $t('SEATS') }}</label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-6"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
            <select v-model="data.CS_VEHICLE.NO_OF_SEATS">
              <!-- <option class="dropdown-link w-dropdown-link" value="" selected>{{ $t('SELECT_VEHICLE_SEATS') }}</option> -->
              <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLov(data.ET_LOVS, 'NO_OF_SEATS')" :key="item.VALUE" :value="item.VALUE">{{
                item.TEXT ? Number(item.TEXT) : $t('SELECT_VEHICLE_SEATS')
              }}</option>
            </select>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_37a01f26-f771-f405-029d-04efe07d96d4-343646d4" class="form_field">
        <validation-provider class="w-100" :name="$t('MODEL')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-6">
              <label class="field_label">{{ $t('MODEL') }}</label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-6"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div data-hover="" data-delay="0" class="dropdown w-dropdown custom-select">
            <select v-model="data.CS_VEHICLE.MODEL">
              <!-- <option class="dropdown-link w-dropdown-link" value="" selected>{{ $t('SELECT_MODEL') }}</option> -->
              <!-- <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLovsDep(data.ET_LOVS_DEP, 'MODEL', data.CS_VEHICLE)" :key="item.VALUE" :value="item.VALUE"> -->
                <option class="dropdown-link w-dropdown-link" v-for="item in $h.getLov(data.ET_LOVS, 'MODEL')" :key="item.VALUE" :value="item.VALUE">
                {{ item.TEXT || $t('SELECT_MODEL') }}</option
              >
            </select>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <div id="w-node-_88390fe4-385b-4fff-fbfb-12b269edcc60-343646d4" class="form_field">
        <validation-provider class="w-100" :name="$t('VEHICLE_VALUE')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="column-4 w-clearfix w-col w-col-4">
              <label class="field_label">{{ $t('VEHICLE_VALUE') }}</label>
            </div>
            <div class="column-13 w-clearfix w-col w-col-8"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="div_form_cell">
            <cleave-money classes="text_field_input text-field w-input" name="VEHICLE_VALUE" v-model="data.CS_VEHICLE.VEHICLE_VALUE" placeholder=""></cleave-money>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <template v-if="data.CS_VEHICLE.VEHICLE_TYPE === '02'">
        <div id="w-node-_30fb7dcd-2ec3-7e0a-fdd7-12a2e4adee03-6251e1ff" class="form_field">
          <validation-provider class="w-100" :name="$t('VEHICLE_USE')" rules="required" v-slot="{ errors, classes }">
            <div class="form_columns w-row">
              <div class="field_column w-clearfix w-col w-col-6">
                <label class="field_label"><span v-html="$t('VEHICLE_USE')"></span></label>
              </div>
              <div class="column-12 w-clearfix w-col w-col-6"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            </div>
            <div class="form_columns split_form_columns w-row">
              <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'VEHICLE_USE')" :key="item.VALUE">
                <label class="radio_gic w-radio">
                  <div
                    :class="[
                      'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                      data.CS_VEHICLE.VEHICLE_USE === item.VALUE && 'w--redirected-checked'
                    ]"
                  ></div>
                  <input v-model="data.CS_VEHICLE.VEHICLE_USE" :value="item.VALUE" type="radio" />
                  <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
                </label>
              </div>
            </div>
            <!-- <div class="form_columns split_form_columns w-row">
              <label v-for="item in $h.getLov(data.ET_LOVS, 'VEHICLE_USE')" :key="item.VALUE" class="field_column w-clearfix w-col w-col-6">
                <input v-model="data.CS_VEHICLE.VEHICLE_USE" :value="item.VALUE" type="radio" />
                <span :class="['field_style w-button', data.CS_VEHICLE.VEHICLE_USE === item.VALUE && 'active']">{{ item.TEXT }}</span>
              </label>
            </div> -->
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </template>
      <template v-else>
        <div id="w-node-_30fb7dcd-2ec3-7e0a-fdd7-12a2e4adee03-343646d4" class="form_field">
          <validation-provider class="w-100" :name="$t('IS_CONVERTIBLE')" rules="required" v-slot="{ errors, classes }">
            <div class="form_columns w-row">
              <div class="field_column w-clearfix w-col w-col-6">
                <label class="field_label"><span v-html="$t('IS_CONVERTIBLE')"></span></label>
              </div>
              <div class="column-12 w-clearfix w-col w-col-6"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
            </div>
            <div class="form_columns split_form_columns w-row">
              <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
                <label class="radio_gic w-radio">
                  <div
                    :class="[
                      'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                      data.CS_VEHICLE.CONVERTIBLE_VEHICLE === item.VALUE && 'w--redirected-checked'
                    ]"
                  ></div>
                  <input v-model="data.CS_VEHICLE.CONVERTIBLE_VEHICLE" :value="item.VALUE" type="radio" />
                  <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
                </label>
              </div>
            </div>
            <!-- <div class="form_columns split_form_columns w-row">
                <label v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE" class="field_column w-clearfix w-col w-col-6">
                  <input v-model="data.CS_VEHICLE.CONVERTIBLE_VEHICLE" :value="item.VALUE" type="radio" />
                  <span :class="['field_style w-button', data.CS_VEHICLE.CONVERTIBLE_VEHICLE === item.VALUE && 'active']">{{ item.TEXT }}</span>
                </label>
              </div> -->
            <span :class="classes">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </template>
      <div id="w-node-_743401ba-2f57-df92-66a7-6fba8d49e5b9-343646d4" class="form_field">
        <validation-provider class="w-100" :name="$t('STEERING_RIGHT_NO_ADJUSTMENRS')" rules="required" v-slot="{ errors, classes }">
          <div class="form_columns w-row">
            <div class="field_column w-clearfix w-col w-col-10">
              <label class="field_label"><span v-html="$t('STEERING_RIGHT_NO_ADJUSTMENRS')"></span></label>
            </div>
            <div class="column-12 w-clearfix w-col w-col-2"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column left w-col w-col-6" v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE">
              <label class="radio_gic w-radio">
                <div
                  :class="[
                    'w-form-formradioinput w-form-formradioinput--inputType-custom radio_button_gic w-radio-input',
                    data.CS_VEHICLE.VEHICLE_WITH_ADJUSTMENTS === item.VALUE && 'w--redirected-checked'
                  ]"
                ></div>
                <input v-model="data.CS_VEHICLE.VEHICLE_WITH_ADJUSTMENTS" :value="item.VALUE" type="radio" />
                <span class="radio-button-label-2 w-form-label">{{ item.TEXT }}</span>
              </label>
            </div>
          </div>
          <!-- <div class="form_columns split_form_columns w-row">
              <label v-for="item in $h.getLov(data.ET_LOVS, 'YES_NO')" :key="item.VALUE" class="field_column w-clearfix w-col w-col-6">
                <input v-model="data.CS_VEHICLE.VEHICLE_WITH_ADJUSTMENTS" :value="item.VALUE" type="radio" />
                <span :class="['field_style w-button', data.CS_VEHICLE.VEHICLE_WITH_ADJUSTMENTS === item.VALUE && 'active']">{{ item.TEXT }}</span>
              </label>
            </div> -->
          <span :class="classes">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <button type="submit" id="w-node-_7143e79d-3470-f95c-b9b4-c693e46cb25e-343646d4" class="submit-button submit-button-2 main_button w-button">{{ $t('CONTINUE') }}</button>
    </form>
  </validation-observer>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    changeManufacturer() {
      this.$emit('change-manufacturer');
    },
    submitForm() {
      // console.log(this.$store.state);
      this.$emit('next');
      console.log('submitted');
    }
  }
};
</script>
